import { Link } from "react-router-dom";
import { Brand } from "./Navbar";
import { useSiteOpen } from "./PrelaunchGate";

const InvestorLinks = () => (
  <div className="flex flex-col gap-2 text-sm">
    <span className="eyebrow mb-2">Investors</span>
    <Link to="/directory" className="text-white/60 hover:text-white" data-testid="footer-directory-link">Find a QI</Link>
    <Link to="/1031-exchange" className="text-white/60 hover:text-white" data-testid="footer-states-link">QIs by state</Link>
  </div>
);

export const Footer = () => {
  const open = useSiteOpen();
  return (
  <footer className="border-t border-white/10 mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
      <div className="space-y-4">
        <Brand />
        <p className="text-sm text-white/50 max-w-xs leading-relaxed">The independent directory and private network for 1031 Qualified Intermediaries.</p>
      </div>
      {open ? <InvestorLinks /> : <div />}
      <div className="flex flex-col gap-2 text-sm">
        <span className="eyebrow mb-2">Intermediaries</span>
        <Link to="/login?mode=register" className="text-white/60 hover:text-white" data-testid="footer-list-link">List your firm</Link>
        <Link to="/waitlist" className="text-white/60 hover:text-white" data-testid="footer-waitlist-link">Paid plan waitlist</Link>
        <a href="https://deferally.com" target="_blank" rel="noreferrer" className="text-white/60 hover:text-white">A sister site of DeferAlly</a>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center text-xs text-white/30">
      © 2026 Findaqualifiedintermediary.com · Listings are provided by intermediaries and are not an endorsement. Not tax or legal advice.
      <span className="block mt-2 text-white/40" data-testid="footer-made-in">Designed &amp; built in Atlanta, GA</span>
    </div>
  </footer>
  );
};
